/* Bonny & Rose: winkelwagen-aanvullingen bovenop Impulse.
   - Verwijderknop haalt het artikel er meteen uit, zonder paginawissel.
   - Fouten komen in de foutbalk van de winkelwagen, niet in een alert.
   Werkt voor de lade en de winkelwagenpagina; zonder JS blijft de noscript-link over. */
(function () {
  'use strict';

  function formOf(el) { return el.closest('form[data-location]'); }

  function foutmelding(el) {
    if (window.theme && theme.showCartError) {
      theme.showCartError(el || document, (theme.strings && theme.strings.cartError) || '');
    }
  }

  /* Waarom dit niet via de aantalknoppen van het thema loopt:
     die luisteraar begint met "geen sleutel of geen aantal? dan niets doen", en
     nul telt daar als geen aantal. Verwijderen kwam dus nooit voorbij die regel;
     de knop bleef vijf seconden grijs staan en er gebeurde niets. Daarom gaat de
     wijziging hier rechtstreeks naar de winkelwagen. */
  function verwijder(sleutel) {
    var url = (window.theme && theme.routes && theme.routes.cartChange) || '/cart/change.js';
    return fetch(url + '?t=' + Date.now(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: sleutel, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    var form = formOf(btn);
    if (!form || !btn.dataset.id) return;

    var row = btn.closest('.cart__item') || btn.closest('[data-cart-item]');
    if (row) row.classList.add('cart__item--removing');
    btn.disabled = true;

    verwijder(btn.dataset.id)
      .then(function (cart) {
        if (cart && cart.status && cart.status !== 200) {
          if (window.theme && theme.showCartError) {
            theme.showCartError(form.parentNode || document, cart.message || cart.description);
          }
          btn.disabled = false;
          if (row) row.classList.remove('cart__item--removing');
          return;
        }

        /* Het thema bouwt op dit bericht elke winkelwagen opnieuw op: de lade,
           de winkelwagenpagina en het bolletje in de kop van de winkel. */
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {
        foutmelding(form.parentNode);
        btn.disabled = false;
        if (row) row.classList.remove('cart__item--removing');
      });
  }, false);

  /* Twee dingen die het thema zelf niet bijhoudt:
       - het aantal stuks naast het woord "Cart" in de kop van de lade
       - de afrekenknop, die het aantal en het bedrag draagt

     Er wordt alleen geschreven in de kop en in de knop. De bewakers kijken naar
     de artikelenlijst en het totaalbedrag, en die staan daar allebei buiten, dus
     dit wekt zichzelf niet opnieuw. */
  function telStuks(vorm) {
    var velden = vorm.querySelectorAll('.js-qty__num');
    var n = 0;
    for (var i = 0; i < velden.length; i++) n += parseInt(velden[i].value, 10) || 0;
    return n;
  }

  function zet(el, tekst) {
    if (el && el.textContent !== tekst) el.textContent = tekst;
  }

  /* De trappen van de staffelkorting. Dezelfde die als automatische korting in
     Shopify staan; hier alleen om te tonen hoever iemand is. */
  var TRAPPEN = [
    { stuks: 2, pct: 10 },
    { stuks: 3, pct: 15 },
    { stuks: 4, pct: 20 }
  ];

  function bereikt(n) {
    var p = 0;
    for (var i = 0; i < TRAPPEN.length; i++) if (n >= TRAPPEN[i].stuks) p = TRAPPEN[i].pct;
    return p;
  }

  function volgende(n) {
    for (var i = 0; i < TRAPPEN.length; i++) if (n < TRAPPEN[i].stuks) return TRAPPEN[i];
    return null;
  }

  function doelBalk(vorm, n) {
    var doel = vorm.querySelector('[data-cart-goal]');
    if (!doel) return;

    /* Lege winkelwagen: dan is er niets te halen en staat de balk in de weg. */
    if (!n) { doel.hidden = true; return; }
    doel.hidden = false;

    var nu = bereikt(n);
    var straks = volgende(n);
    var tekst;
    if (!straks) {
      tekst = 'You are saving ' + nu + '% — our biggest discount';
    } else {
      var erbij = straks.stuks - n;
      var meer = 'Add ' + erbij + (erbij === 1 ? ' more' : ' more items') + ' and save ' + straks.pct + '%';
      tekst = nu ? 'Saving ' + nu + '% · ' + meer.charAt(0).toLowerCase() + meer.slice(1) : meer;
    }
    zet(doel.querySelector('[data-cart-goal-text]'), tekst);

    var stappen = doel.querySelectorAll('[data-goal-step]');
    for (var i = 0; i < stappen.length; i++) {
      var nodig = parseInt(stappen[i].getAttribute('data-goal-step'), 10);
      stappen[i].classList.toggle('is-reached', n >= nodig);
      stappen[i].classList.toggle('is-next', !!straks && straks.stuks === nodig);
    }
  }

  function bijwerken() {
    var vormen = document.querySelectorAll('form[data-location]');
    for (var i = 0; i < vormen.length; i++) {
      var vorm = vormen[i];
      var n = telStuks(vorm);

      var kop = vorm.querySelector('[data-cart-drawer-count]');
      if (kop) zet(kop, n ? '(' + n + ')' : '');

      doelBalk(vorm, n);

      var knop = vorm.querySelector('.cart__checkout');
      if (!knop) continue;

      /* De grondtekst één keer vastleggen, anders plakt het bedrag er bij elke
         wijziging opnieuw achter. */
      var basis = knop.getAttribute('data-br-basis');
      if (!basis) {
        basis = (knop.textContent || 'Checkout').trim();
        knop.setAttribute('data-br-basis', basis);
      }

      var bedragEl = vorm.querySelector('[data-subtotal]');
      var bedrag = bedragEl ? (bedragEl.textContent || '').trim() : '';
      zet(knop, bedrag ? basis + ' · ' + bedrag : basis);
    }
  }

  function volgWinkelwagen() {
    if (!window.MutationObserver) { bijwerken(); return; }
    var kijker = new MutationObserver(bijwerken);
    var lijsten = document.querySelectorAll('[data-products], [data-subtotal]');
    for (var i = 0; i < lijsten.length; i++) {
      kijker.observe(lijsten[i], { childList: true, subtree: true, characterData: true });
    }
    bijwerken();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', volgWinkelwagen);
  } else {
    volgWinkelwagen();
  }

  // netwerkfout bij een aantalwijziging zichtbaar maken
  document.addEventListener('cart:error', function (e) {
    if (window.theme && theme.showCartError) {
      theme.showCartError(document, (e.detail && e.detail.message) || (theme.strings && theme.strings.cartError));
    }
  });
})();
